module.exports = "/_next/static/videos/6-d2d123eb1967247b3500095e8eac06ae.webm";